import React from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import { push } from '@lagunovsky/redux-react-router'
import ActionComponent from '../../../components/ActionComponent'
import AgriAction from '../../../agriAdministration/actions/AgriAction'
import DtoSurvey from '../../dto/DtoSurvey'
import FormFilterSurveys from '../panels/FormFilterSurveys'
import SurveyCard from '../panels/SurveyCard'
import { groupBy, orderBy, reverse } from 'lodash'
import { getSandreLabel } from 'utils/StringUtil'
import { SANDRE } from 'referencial/constants/ReferencialConstants'
import ReferencialAction from 'referencial/action/ReferencialAction'
import { Accordion, AccordionDetails, AccordionSummary, Button, Dialog, DialogActions, DialogContent, Grid2 } from '@mui/material'
import NumberField from 'components/forms/NumberField'
import DtoSurveyWithStats from '../../dto/DtoSurveyWithStats'
import ProgressCard from 'components/card/ProgressCard'
import Input from 'components/forms/Input'
import ToastrAction from 'toastr/actions/ToastrAction'
import SimpleTabList from 'components/list/SimpleTabList'
import Select from 'components/forms/Select'
import EvolVolumesChartPanel from '../panels/EvolVolumesChartPanel'
import HomeAction from 'home/actions/HomeAction'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import { SURVEY_TYPES } from 'agriAdministration/constants/AgriConstants'

class SurveysDashboardApp extends ActionComponent {
    constructor(props) {
        super(props)
        this.state = {
            filter: {},
            newSurvey: new DtoSurvey({ surveyType: 1, contributorId: props.accountUser.contributorCode }),
            dataLoaded: false,
        }
    }

    componentDidMount = () => {
        this.props.fetchSurveysWithStats().then(() => {
            this.setState({ dataLoaded: true })
        })
        if (!this.props.sandreCodes.length) {
            this.props.fetchSandreCodes()
        }
        this.getActions()
    }

    componentDidUpdate = () => {
        this.setTitle()
        this.getActions()
    }

    setTitle = () => {
        this.props.setTitle([{
            title: i18n.planning,
            href: 'planning/dashboard',
        }, {
            title: i18n.surveys,
            href: 'planning/surveys',
        }])
    }

    getActions = () => {
        const { accountUser } = this.props
        const actions = accountUser.isAdmin === '1' || accountUser.metadata === '1' ? {
            new: () => this.setState({ open: true }),
        } : {}
        this.setActions(actions)
    }

    getSurveysByStatus = surveys => {
        const groupedSurveys = groupBy(surveys, 'statusCode')

        return Object.keys(groupedSurveys).map(key => {
            return this.getPanelList(groupedSurveys[key], getSandreLabel(this.props.sandreCodes, SANDRE.CMS_STATUT, key))
        })
    }

    getSurveysByDate = surveys => {
        const groupedSurveys = groupBy(surveys, 'year')

        return reverse(Object.keys(groupedSurveys).map(key => {
            return this.getPanelList(groupedSurveys[key], key)
        }))
    }

    getSurveysByOrganism = surveys => {
        const groupedSurveys = groupBy(surveys, 'organism')

        return Object.keys(groupedSurveys).map(key => {
            return this.getPanelList(groupedSurveys[key], key === '' ? i18n.none : key)
        })
    }

    getPanelList = (groups, title) => (
        <Grid2 size={12}>
            <Accordion defaultExpanded round>
                <AccordionSummary round>
                    {title}
                </AccordionSummary>
                <AccordionDetails sx={{ padding: 0 }}>
                    {groups.map(survey => (
                        <SurveyCard
                            key={survey.idSurvey}
                            survey={survey}
                            progress={{
                                nbDeclarations: survey.nbDeclarations,
                                nbDeclarationsValidated: survey.nbDeclarationsValidated,
                            }}
                        />
                    ))}
                </AccordionDetails>
            </Accordion>
        </Grid2>
    )

    getFilteredSurveys = () => {
        const { filter } = this.state
        const { surveysWithStats } = this.props

        const startDateFilter = filter.startDate ? surveysWithStats.filter(survey => survey.startDate >= filter.startDate) : surveysWithStats
        const endDateFilter = filter.endDate ? startDateFilter.filter(survey => survey.endDate <= filter.endDate) : startDateFilter
        const statusFilter = filter.status ? endDateFilter.filter(survey => survey.statusCode === filter.status) : endDateFilter

        return orderBy(statusFilter, 'year', 'desc')
    }

    getSurveys = (tab) => {
        const { contributors } = this.props

        const filteredSurveys = this.getFilteredSurveys().map((s) => ({
            ...s,
            organism: s.contributorId ? contributors.find((c) => c.id === s.contributorId)?.name : '',
        }))

        switch (tab) {
            case 'statut':
                return this.getSurveysByStatus(filteredSurveys)
            case 'date':
                return this.getSurveysByDate(filteredSurveys)
            case 'organism':
                return this.getSurveysByOrganism(filteredSurveys)
            default:
                return []
        }
    }

    handleOnSave = () => {
        const { newSurvey } = this.state
        if (newSurvey.year && newSurvey.name && newSurvey.surveyType) {
            this.props.createSurvey({
                ...newSurvey,
                idSurvey: -1,
                statusCode: 2,
            }).then((json) => {
                this.props.fetchSurveysWithStats()
                this.props.push(`/survey/${json.id}`)
            })
        } else {
            this.props.error(i18n.pleaseCompleteAllRequiredField)
        }
    }

    render = () => {
        const { open, newSurvey, dataLoaded } = this.state
        const { contributors } = this.props

        return (
            <Grid2 container spacing={1} sx={{ padding: '10px 10px 100px 0' }}>
                <Grid2 container size={12} spacing={1} alignItems='flex-start'>
                    <Grid2 size={8}>
                        <FormFilterSurveys
                            onChange={obj => this.setState({ filter: obj })}
                        />
                    </Grid2>
                    <Grid2 size={4}>
                        <EvolVolumesChartPanel
                            statistics={this.props.surveysWithStats}
                            keyVolume='requestedVolume'
                            select
                            selectOptions={[{
                                value: 'requestedVolume',
                                label: i18n.requestedVolume,
                            }, {
                                value: 'allocatedVolume',
                                label: i18n.allocatedVolume,
                            }, {
                                value: 'allowedVolume',
                                label: i18n.allowedVolume,
                            }]}
                        />
                    </Grid2>
                </Grid2>
                <Grid2 size={12}>
                    <SimpleTabList
                        tabs={[{
                            constant: 'statut',
                            label: i18n.byStatus,
                            icon: 'edit',
                        },
                        {
                            constant: 'date',
                            label: i18n.perYear,
                            icon: 'insert_invitation',
                        },
                        {
                            constant: 'organism',
                            label: i18n.byOrganism,
                            icon: 'person',
                        }]}
                    >
                        {tab => dataLoaded ? (
                            <Grid2 container spacing={1}>
                                {this.getSurveys(tab)}
                            </Grid2>
                        ) : <ProgressCard indeterminate round withoutCard /> }
                    </SimpleTabList>
                </Grid2>
                <Dialog
                    fullWidth
                    maxWidth='sm'
                    open={open}
                >
                    <DefaultDialogTitle title={i18n.createSurvey} onClose={() => this.setState({ open: false })} />
                    <DialogContent>
                        <Grid2 container spacing={1}>
                            <Grid2 size={6}>
                                <Input
                                    title={i18n.name}
                                    value={newSurvey.name}
                                    onChange={value => this.setState({ newSurvey: { ...newSurvey, name: value } })}
                                    obligatory
                                />
                            </Grid2>
                            <Grid2 size={6}>
                                <NumberField
                                    title={i18n.year}
                                    value={newSurvey.year}
                                    onChange={value => this.setState({ newSurvey: { ...newSurvey, year: value } })}
                                    obligatory
                                />
                            </Grid2>
                            <Grid2 size={6}>
                                <Select
                                    label={i18n.type}
                                    options={[{
                                        value: SURVEY_TYPES.ANNUAL,
                                        label: i18n.annual,
                                    }, {
                                        value: SURVEY_TYPES.INTERMEDIATE,
                                        label: i18n.intermediate,
                                    }]}
                                    value={newSurvey.surveyType}
                                    integerValue
                                    onChange={value => this.setState({ newSurvey: { ...newSurvey, surveyType: value } })}
                                    noNullValue
                                    obligatory
                                />
                            </Grid2>
                            <Grid2 size={6}>
                                <Select
                                    label={i18n.organism}
                                    options={contributors}
                                    value={newSurvey.contributorId}
                                    keyValue='id'
                                    onChange={value => this.setState({ newSurvey: { ...newSurvey, contributorId: value } })}
                                />
                            </Grid2>
                        </Grid2>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleOnSave} variant='contained' color='primary'>
                            {i18n.add}
                        </Button>
                    </DialogActions>
                </Dialog>
            </Grid2>
        )
    }
}

SurveysDashboardApp.propTypes = {
    surveysWithStats: PropTypes.arrayOf(PropTypes.instanceOf(DtoSurveyWithStats)),
}

const mapStateToProps = store => ({
    surveysWithStats: store.AgriReducer.surveysWithStats,
    sandreCodes: store.ReferencialReducer.sandreCodes,
    accountUser: store.AccountReducer.accountUser,
    contributors: store.ContributorReducer.contributors,
})

const mapDispatchToProps = {
    push,
    fetchSurveysWithStats: AgriAction.fetchSurveysWithStats,
    fetchSandreCodes: ReferencialAction.fetchSandreCodes,
    setTitle: HomeAction.setTitle,
    createSurvey: AgriAction.createSurvey,
    error: ToastrAction.error,
}

export default connect(mapStateToProps, mapDispatchToProps)(SurveysDashboardApp)
